import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import './PartnersList.css';
import PartnerModal from '../PartnerModal/PartnerModal';

function PartnersList({ partners = [] }) {
  const [openPartner, setOpenPartner] = useState(null);
  const [openAttrs, setOpenAttrs] = useState([]);
  const [openTags, setOpenTags] = useState([]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!partners.length) return null;

  const processAttrs = (arr) =>
    arr.map((a) => {
      if (typeof a === 'string') {
        let variant = '';
        if (/code/i.test(a)) variant = 'code';
        else if (/%/.test(a) || /bonus/i.test(a)) variant = 'bonus';
        else variant = 'default';
        return { label: a, variant };
      }
      return { label: String(a.label || a), variant: a.variant || 'default' };
    });

  const openModal = (p) => {
    setOpenAttrs(processAttrs(p.attrs || []));
    setOpenTags(processAttrs(p.tags || []));
    setOpenPartner(p);
  };

  const closeModal = () => {
    setOpenPartner(null);
    setOpenAttrs([]);
    setOpenTags([]);
    document.body.style.overflow = '';
  };

  return (
    <>
      <div className="partners-list">
        {partners.map((p) => {
          const attrs = processAttrs(p.attrs || []);

          return (
            <div key={p.id} className="partner-card">
              <div className="partner-left">
                <div className="partner-logo-wrapper">
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="partner-logo"
                    loading="lazy"
                    decoding="async"
                    onClick={() => p.href && window.open(p.href, '_blank', 'noreferrer')}
                    style={{ 
                      cursor: p.href ? 'pointer' : 'default',
                      backgroundColor: p.background_color || '#1a1a2e'
                    }}
                  />
                  {p.href && (
                    <div className="partner-logo-tooltip">
                      <span className="partner-logo-tooltip-text">{p.href}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="partner-center">
                <div className="partner-title">{p.name}</div>
                <div className="partner-desc">{p.description}</div>
              </div>

              <div className="partner-middle">
                <div className="partner-attr-group">
                  {attrs.map((attr, i) => (
                    <div
                      key={i}
                      className={`partner-attr attr-${attr.variant}`}
                    >
                      {attr.label}
                    </div>
                  ))}
                </div>
              </div>

              <div className="partner-right">
                <button
                  type="button"
                  className="partner-info-icon"
                  onClick={() => openModal(p)}
                  aria-label={`Detalhes de ${p.name}`}
                >
                  <FaInfoCircle className="partner-info-icon-inner" />
                  <span className="partner-info-label">Detalhes</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {openPartner && (
        <PartnerModal
          partner={openPartner}
          attrs={openAttrs}
          tags={openTags}
          onClose={closeModal}
        />
      )}
    </>
  );
}

export default PartnersList;
